import { render } from "./Forbidden.vue?vue&type=template&id=35b5a763"
import script from "./Forbidden.vue?vue&type=script&lang=js"
export * from "./Forbidden.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__